import { axios } from '@/utils/request'

const api = {

  order: '/order/orderWechat',
}
// 列表
export function queryOrderList (parameter) {
  return axios({
    url: api.order + '/getPricePcList',
    method: 'get',
    params: parameter
  })
}

// 审核
export function markupOrderPrice (parameter) {
  return axios({
    url: api.order + '/priceSupplementEdit',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 详情
export function getPcSupplementInfo (id) {
  return axios({
    url: api.order + '/getPcSupplementInfo',
    method: 'get',
    params: {
      id:id
    }  
  })
}
